import React, { useRef } from 'react'
import { IErrorResponse } from '../types/ErrorResponse'
import { TProductPagination, TProductStatus } from '../types/Product'
import ProductController from '../controllers/ProductController'
import { ProductSituationEnum } from '../types/Situation'

export interface IProductsProp {
  tenantId?: string
  page: number
  rows: number
  name?: string
  active: boolean | null
  status: TProductStatus
  productSituation: ProductSituationEnum | null
}

const valueDefault = {
  items: [],
  page: 0,
  rowsPerPage: 0,
  totalPages: 0,
  total: 0,
}

export const useProducts = ({
  tenantId,
  page,
  rows,
  name,
  active,
  status,
  productSituation,
}: IProductsProp) => {
  const [loading, setLoading] = React.useState<boolean>(false)
  const [data, setData] = React.useState<TProductPagination>(valueDefault)
  const [error, setError] = React.useState<string>('')

  const executing = useRef(false)

  const execute = async () => {
    if (!loading && !executing.current) {
      executing.current = true
      try {
        setLoading(true)

        if (error !== '') {
          setError('')
        }

        const response = await ProductController.getAll({
          tenantId,
          page,
          rows,
          name,
          active,
          status,
          productSituation,
        })
        const responseError = response as IErrorResponse
        const responseData = response as TProductPagination

        if (responseError.code) {
          setError(responseError.error)
          setData(valueDefault)
        } else {
          setData(responseData)
        }
      } catch (e) {
        var message = 'Erro não identificado'
        if (typeof e === 'string') {
          message = e.toUpperCase()
        } else if (e instanceof Error) {
          const err = e as Error
          message = err.message
        }
        setError(message)
      } finally {
        setLoading(false)
        executing.current = false
      }
    }
  }

  React.useEffect(() => {
    execute()
  }, [page, rows, active, status, productSituation])

  const clear = () => {
    setError('')
  }

  return {
    loading,
    data,
    error,
    execute,
    clear,
  }
}
